import React from 'react';
import { faRectangleHistoryCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Row, Col, Placeholder, Button, Form } from 'react-bootstrap-5';

import ProductFeature from '../product_feature';
import { selectEmbeddedMode } from 'bundles/connect/components/store/selectors/ui';
import { useSelector } from 'react-redux';
import { BUILDOUT_CRM_MODE } from 'bundles/connect/components/embedded_mode';

export default function OffMarketResultLoader() {
  const embeddedMode = useSelector(selectEmbeddedMode);

  return (
    <Card className="mb-3 overflow-hidden">
      <Row className="g-0 align-items-stretch">
        <Col className="d-flex flex-column">
          <div className="d-flex flex-grow-1">
            {embeddedMode !== BUILDOUT_CRM_MODE && (
              <ProductFeature product="prospecting">
                <div className="py-2 ps-2" onClick={e => e.stopPropagation()}>
                  <Form.Check disabled type="checkbox" />
                </div>
              </ProductFeature>
            )}
            <Card.Body className="p-2">
              <div className="d-flex flex-column justify-content-md-between gap-3 gap-md-2 h-100">
                <Placeholder animation="wave">
                  <div>
                    <Placeholder as="div" className="rounded" xs={12} />
                  </div>
                  <Placeholder as="div" className="rounded" xs={12} />
                </Placeholder>
                <Placeholder animation="wave">
                  <div>
                    <Placeholder as="div" className="rounded" xs={8} />
                  </div>
                  <div>
                    <Placeholder as="div" className="rounded" xs={8} />
                  </div>
                </Placeholder>
              </div>
            </Card.Body>
          </div>
        </Col>
        <Col className="map-result-thumb d-md-block placeholder-wave placeholder" />
        {embeddedMode !== BUILDOUT_CRM_MODE && (
          <ProductFeature product="prospecting">
            <Col
              className="d-flex flex-column border-start"
              xs={{ order: 'last', span: 'auto' }}
            >
              <div className="flex-fill border-bottom">
                <div className="align-content-center text-center p-2 h-100">
                  <FontAwesomeIcon
                    className="text-primary"
                    icon={faRectangleHistoryCirclePlus}
                  />
                </div>
              </div>
              <div className="flex-fill clickable">
                <Button className="h-100" variant="text-primary">
                  <FontAwesomeIcon icon={faBookmark} />
                </Button>
              </div>
            </Col>
          </ProductFeature>
        )}
      </Row>
    </Card>
  );
}
